/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlViolationsWithStandardCoverageWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ControlViolationsWithStandardCoverageWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ControlViolationsWithStandardCoverageWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ControlViolationsWithStandardCoverageWidgetConfiguration>): ControlViolationsWithStandardCoverageWidgetConfiguration {
        let obj = Object.assign(new ControlViolationsWithStandardCoverageWidgetConfiguration(), model);
        ControlViolationsWithStandardCoverageWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlViolationsWithStandardCoverageWidgetConfiguration>): ControlViolationsWithStandardCoverageWidgetConfiguration {
        if (!model) return null;
        return ControlViolationsWithStandardCoverageWidgetConfiguration.newInstance(<ControlViolationsWithStandardCoverageWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlViolationsWithStandardCoverageWidgetConfiguration) {
        if (!obj) return;

        models.ControlViolationsWithStandardCoverageWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlViolationsWithStandardCoverageWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ControlViolationsWithStandardCoverageWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
